const asciiSignature = () => {
    if (typeof window.__PRERENDER_INJECTED === "undefined") {
        // eslint-disable-next-line no-console
        console.log(`
                      ___ _      _   _
/\\_/\\___  _   _ _ __ /   (_) ___| |_(_) ___  _ __   __ _ _ __ _   _
\\_ _/ _ \\| | | | '__/ /\\ / |/ __| __| |/ _ \\| '_ \\ / _\` | '__| | | |
 / \\ (_) | |_| | | / /_//| | (__| |_| | (_) | | | | (_| | |  | |_| |
 \\_/\\___/ \\__,_|_|/___,' |_|\\___|\\__|_|\\___/|_| |_|\\__,_|_|   \\__, |
                                                              |___/
    `);
    }
};

export default asciiSignature;



// WEBPACK FOOTER //
// ./src/asciiSignature.js